import { Section } from './section'
import { BodyText, BulletList, Subheading, Subsection } from './styles'

export const Guarantor = () => {
  return (
    <Section title="Guarantor">
      <BodyText>The details of the person you have chosen to be your guarantor.</BodyText>

      <Subsection>
        <Subheading>Why do I need this?</Subheading>
        <BodyText>
          Guarantors are used as a guarantee in case you are in a position where you cannot
          pay your rent or if you don’t quite meet affordability for the property.
        </BodyText>
      </Subsection>

      <Subsection>
        <Subheading>What you will need</Subheading>
        <BulletList>
          <li>Guarantor's full name</li>
          <li>Guarantor's email address</li>
          <li>Guarantor's phone number</li>
        </BulletList>
      </Subsection>

      <BodyText>
        We will contact your nominated guarantor and ask them to fill in a referencing
        application.
      </BodyText>
    </Section>
  )
}
